import * as React from "react";
import { useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { GridTable } from "../../shared/ReusableComponents/GridTable";
import { Box, Link, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../store/currentPreferencesSlice";
import { useNavigate } from "react-router-dom";
import { DateFormatter } from "../../shared/utils/DateFormatter";
import { CommonFunctions } from "../../shared/utils/CommonFunctions";
import { caseRepository } from "../../services/caseRepository";
import { Heading, SearchBar } from "../../shared/ReusableComponents";
import { UserRoles, UserRolesInfo } from "../../shared/constants/enums";

export const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state: any) => state.login);
  const userRole = UserRolesInfo[auth.userInfo?.roleId as UserRoles];

  const renderMRN = (params: any) => {
    function handler() {
      navigate(`${userRole.route}/casedetails/${params.row.id}`);
    }

    return (
      <Link onClick={handler} underline="always" sx={{ cursor: "pointer" }}>
        <Tooltip title={params.value}>{params.value}</Tooltip>
      </Link>
    );
  };

  const columns: GridColDef[] = [
    {
      field: "mrn",
      headerName: "MRN",
      type: "number",
      sortable: true,
      renderCell: renderMRN,
    },
    {
      field: "patientName",
      headerName: "Patient Name",
      valueGetter: (value, row) =>
        `${row.patientFirstName} ${
          row.patientMiddleName ? row.patientMiddleName + " " : ""
        }${row.patientLastName}`.trim(),
    },
    {
      field: "dob",
      headerName: "Age",
      valueGetter: (value, row) => DateFormatter.calculateAge(row.dob),
    },
    {
      field: "isATSI",
      headerName: "Aboriginal and Torres Strait Islander",
      valueGetter: (value, row) => (row.isATSI === true ? "Yes" : "No"),
    },
    {
      field: "wardName",
      headerName: "Ward Name",
    },
    {
      field: "diagnosis",
      headerName: "Admission Diagnosis",
    },
  ];

  const [originalData, setOriginalData] = React.useState<any[]>([]);
  const [filteredData, setFilteredData] = React.useState<any[]>(originalData);
  const currentPrefs = useSelector((state: any) => state.currentPreferences);
  const userInfo = useSelector((state: any) => state.login?.userInfo);
  const [searchText, setSearchText] = React.useState<string>("");

  React.useEffect(() => {
    CommonFunctions.openConsentForm();
  }, []);

  React.useEffect(() => {
    if (currentPrefs.isConsentProvided && userInfo) {
      dispatch(showLoader());
      caseRepository.GetAssignedCases().then((data) => {
        if (data) {
          setOriginalData(data);
          setFilteredData(data);
        }
        dispatch(hideLoader());
      });
    }
  }, [currentPrefs.isConsentProvided, dispatch, userInfo]);

  const validateMRN = (input: string) => {
    const mrnPattern = /^[0-9]+$/;
    return mrnPattern.test(input);
  };

  const handleSearch = (searchText: string) => {
    setSearchText(searchText);
    dispatch(showLoader());

    if (searchText && !validateMRN(searchText)) {
      setFilteredData([]);
      dispatch(hideLoader());
    } else {
      if (!searchText) {
        setFilteredData(originalData);
      } else {
        const filteredRows = originalData?.filter(
          (row: any) =>
            row.mrn && row.mrn.toString().includes(searchText.toLowerCase())
        );
        setFilteredData(filteredRows);
      }
      dispatch(hideLoader());
    }
  };

  return (
    <div style={{ backgroundColor: "#fff", padding: 0 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 20px 0px 20px",
        }}
      >
        <Heading type={"h5"} isBold={true} text="Case List" />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          <span className="grey-dark-background">
            <SearchBar
              value={searchText}
              onSearch={handleSearch}
              placeholder="Search by MRN"
              className="search-bar-temp-width"
            />
          </span>
        </div>
      </Box>
      <GridTable
        rows={filteredData}
        columns={columns}
        pageSizeOptions={[5, 10, 15]}
        initialPageSize={10}
      />
    </div>
  );
};
